import { ValuatorFilterRequest } from "@/main/models/request/valuatorRequest";
import { ValuatorActionTypes, ValuatorTypes } from "./valuatorTypes";
import { KeyValue } from "@/main/models/common";

export function getValuators(request: ValuatorFilterRequest): ValuatorActionTypes {
	return {
		type: ValuatorTypes.GET_VALUATORS,
		payload: { request },
	};
}

export function saveValuators(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ValuatorActionTypes {
	return {
		type: ValuatorTypes.SAVE_VALUATORS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerValuators(): ValuatorActionTypes {
	return {
		type: ValuatorTypes.RESET_REDUCER_VALUATORS,
	};
}
